import type { OrderTabProps } from '../../../../types/LayoutConfig';
import { useDefaultOrderTabs } from '../../../Blotters/Orders/defaults';
import { MobileBlotterPanel, type MobileBlotterPanelProps } from './MobileBlotterPanel';

/** Placeholder-only mobile orders content; uses `TradingPlaceholder` via `MobileBlotterPanel`. */
export function MobileOrdersBlotter(props: Omit<MobileBlotterPanelProps<OrderTabProps>, 'defaultTabs'>) {
  const { tabs } = useDefaultOrderTabs();
  return <MobileBlotterPanel<OrderTabProps> {...props} defaultTabs={tabs} />;
}
